import React from "react";
import ImportContacts from "src/importExport/import/importContacts";
import { MeetingDefinition } from "src/types";

interface WebinarEditInviteGuestsProps {
  meetingTemplate?: MeetingDefinition;
  setDisableSave?: (value: boolean) => void;
}

function WebinarEditInviteGuests({
  meetingTemplate,
  setDisableSave,
}: WebinarEditInviteGuestsProps) {
  return (
    <ImportContacts
      preSelectedMeetingTemplate={meetingTemplate}
      setDisableSave={setDisableSave}
    />
  );
}

export default React.memo(WebinarEditInviteGuests);
